import Grid from "@mui/material/Grid";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
const GenderFormInputs = ({ formData, onFormDataChange }) => {
  const handleChange = (field, value) => {
    onFormDataChange({ ...formData, [field]: value });
  };

  return (
    <Grid container spacing={2} mt={1}>
      <Grid item xs={12}>
        <MDTypography
          display="block"
          whiteSpace="pre-line"
          variant="h6"
          color="warning"
        >Scraped Item Qty: {formData.qty}</MDTypography>
      </Grid>
      <Grid item xs={6}>
        <MDInput
          label="Male"
          type="number"
          value={formData.male}
          inputProps={{ min: 0, max: 50 }}
          onChange={(e) => handleChange("male", e.target.value)}
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <MDInput
          label="Female"
          type="number"
          value={formData.female}
          inputProps={{ min: 0, max: 50 }}
          onChange={(e) => handleChange("female", e.target.value)}
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <MDInput
          label="Male Calf"
          type="number"
          value={formData.male_calf}
          inputProps={{ min: 0, max: 50 }}
          onChange={(e) => handleChange("male_calf", e.target.value)}
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <MDInput
          label="Female Calf"
          type="number"
          value={formData.female_calf}
          inputProps={{ min: 0, max: 50 }}
          onChange={(e) => handleChange("female_calf", e.target.value)}
          fullWidth
        />
      </Grid>

      <Grid item xs={12}>
        <MDInput
          label="Unsexed Calf"
          type="number"
          value={formData.unsexed_calf}
          inputProps={{ min: 0, max: 50 }}
          onChange={(e) => handleChange("unsexed_calf", e.target.value)}
          fullWidth
        />
      </Grid>
    </Grid>
  );
};

export default GenderFormInputs;
